export const UPLOAD_LEADER_LOCK_PREFIX = 'vision-lab:upload-leader';
export const UPLOAD_TAB_PRESENCE_PREFIX = 'vl-upload-tab:v1';
export const UPLOAD_LEADER_CHANNEL_PREFIX = 'vl-upload-leader:v1';
export const UPLOAD_LEADER_ELECTION_DELAY_MS = 400;
export const UPLOAD_LEADER_HEARTBEAT_MS = 5_000;
export const UPLOAD_TAB_INACTIVE_STALE_MS = 15_000;
export const UPLOAD_WEB_LOCK_RETRY_MS = 2_000;
export const UPLOAD_RESOURCE_LOCK_PREFIX = 'vision-lab:local-upload';
